import { Icon, type IconName } from './Icon'
import styles from './EmptyRow.module.css'

interface EmptyRowProps {
  icon?: IconName
  title: string
  description: string
}

export function EmptyRow({ icon = 'check', title, description }: EmptyRowProps) {
  return (
    <div className={styles.empty}>
      <div className={styles.badge}>
        <Icon name={icon} size={30} />
      </div>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
    </div>
  )
}
